export default __webpack_public_path__ + "media/images/react_icons/property/3dtour-805072009f0144aafd7f751770c14f41.svg";